<div class="row">
    <div class="col-12 text-center">
      <h2>Backtester Trading Systems</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card" cascade="true" narrower="true">
        <div class="table-wrapper">
          <div class="px-4">
            <table class="table mb-0" mdbTable hover="true">
              <thead>
                <tr>
                  <th class="th-md">#</th>
                  <th class="th-md">Market</th>
                  <th class="th-md">Ultimo giorno base dati</th>
                  <th class="th-md">Ultimo giorno simulatore</th>
                  <th class="th-md">Aggiornamento</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of markets; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{m.market}}</td>
                  <td>{{m.hys}}</td>
                  <td>{{m.sim}}</td>
                  <td>{{m.update}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-right">
      <button (click)="backtester()" class="btn btn-primary">Backtester</button>
      <div>{{logMarkets}}</div>
      <div *ngIf="updateOK" class="alert alert-success">Backtest completato!</div>
      <div *ngIf="updateKO" class="alert alert-danger">Backtest Fallito!</div>
    </div>
  </div>
  <div class="card"cascade="true" narrower="true">
    <!--Card image-->
    <div
      class="view view-cascade gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center">
  
      <div>
        <button mdbBtn color="white" outline="true" rounded="true" size="sm" type="button" class="px-2" mdbWavesEffect>
            <i class="fas fa-th-large"></i>
        </button>
        <button mdbBtn color="white" outline="true" rounded="true" size="sm" type="button" class="px-2" mdbWavesEffect>
            <i class="fas fa-columns"></i>
        </button>
      </div>
  
      <a href="" class="white-text mx-3">Lista Trading Systems</a>
  
      <div>
        <button type="button" mdbBtn color="white" outline="true" rounded="true" size="sm" class="px-2" mdbWavesEffect>
            <i class="fas fa-pencil-alt"></i>
        </button>
        <button type="button" mdbBtn color="white" outline="true" rounded="true" size="sm" class="px-2" mdbWavesEffect>
            <i class="fas fa-clock"></i>
        </button>
        <button type="button" mdbBtn color="white" outline="true" rounded="true" size="sm" class="px-2" mdbWavesEffect>
            <i class="fas fa-info-circle"></i>
        </button>
      </div>
  
    </div>
    <!--/Card image-->
  
    <div class="px-4">
  
      <div class="table-wrapper">
        <!--Table-->
        <table class="mb-0" mdbTable hover="true">
  
          <!--Table head-->
          <thead>
            <tr>
              <!-- <th>
                <mdb-checkbox></mdb-checkbox>
              </th> -->
              <th class="th-lg">
                <a (click)="sortBy('market')">Mercato
                  <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('pattern')">Pattern
                    <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('dayweek')">Giorno
                  <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('orap')">Ora P
                  <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('oraclosep')">Ora Close
                  <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('numop')">Num Op
                  <i class="fas fa-sort"></i>
                </a>
              </th>
              <th class="th-lg">
                <a (click)="sortBy('profit')">Profit
                  <i class="fas fa-sort"></i>
                </a>
              </th>
            </tr>
          </thead>
          <!--Table head-->
  
          <!--Table body-->
          <tbody>
            <tr *ngFor="let row of tableData;let i = index">
              <!-- <th scope="row">
                <mdb-checkbox></mdb-checkbox>
              </th> -->
              <td>{{row.market}}</td>
              <td>{{row.pattern}}</td>
              <td>{{row.dayweek}}</td>
              <td>{{row.orap}}</td>
              <td>{{row.oraclosep}}</td>
              <td>{{row.numop}}</td>
              <td>{{row.profit}}</td>
            </tr>
          </tbody>
          <!--Table body-->
        </table>
        <!--Table-->
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12 text-right">
  <button type="button" mdbBtn color="blue" outline="true" rounded="true" size="md" class="px" (click)="updateReports()">AGGIORNA REPORTS</button>
      </div>
    </div> -->
</div>